import styled from "styled-components";

export const Container = styled.div`
  padding-left: 38px;
  width: 100%;

  .tag-text {
    margin-left: 10px;
    margin-bottom: 0px;
    text-align: center;
    font-size: 14px;
    font-style: normal;
    font-weight: 600;
    line-height: 20px;
    color: ${({ theme }) => theme.colors.surface.onSurface};
  }

  .clickable {
    cursor: pointer;
  }
`;
